import React, { forwardRef } from "react";
import { ArrowRight } from "@/components/icons";

interface ShowAllButtonProps {
  totalCount: number;
  isExpanded: boolean;
  onToggle: () => void;
}

export const ShowAllButton = forwardRef<HTMLButtonElement, ShowAllButtonProps>(
  ({ totalCount, isExpanded, onToggle }, ref) => {
    if (isExpanded) {
      return (
        <button
          ref={ref}
          onClick={onToggle}
          className="bg-white text-gray-900 w-full rounded-full transition-all py-4 px-6"
        >
          <div className="font-bold text-base flex items-center gap-2 justify-center text-center">
            Show less
          </div>
        </button>
      );
    }

    return (
      <button
        ref={ref}
        onClick={onToggle}
        className="not-prose bg-white text-gray-900 w-full rounded-full transition-all border border-putty-700 py-3 px-4"
      >
        <div className="font-bold text-base flex items-center gap-2 justify-center text-center">
          Show all {totalCount} options
          <ArrowRight />
        </div>
      </button>
    );
  },
);

ShowAllButton.displayName = "ShowAllButton";
